import React, { ReactNode } from 'react';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import useStyles from '../../assets/jss/material-dashboard-pro-react/components/buttonStyleTS';
import { ButtonBaseProps } from '@material-ui/core';

type Color =
	| 'primary'
	| 'info'
	| 'success'
	| 'warning'
	| 'danger'
	| 'rose'
	| 'white'
	| 'twitter'
	| 'facebook'
	| 'google'
	| 'linkedin'
	| 'pinterest'
	| 'youtube'
	| 'tumblr'
	| 'github'
	| 'behance'
	| 'dribbble'
	| 'reddit'
	| 'transparent'
	| 'default';
type Size = 'sm' | 'lg';

interface IButtonProps extends ButtonBaseProps {
	id?: string;
	color?: Color;
	size?: Size;
	simple?: boolean;
	round?: boolean;
	fullWidth?: boolean;
	disabled?: boolean;
	block?: boolean;
	link?: boolean;
	justIcon?: boolean;
	className?: string;
	muiClasses?: Object;
	children?: ReactNode;
	'data-testid'?: string;
}

export default function RegularButton(props: IButtonProps) {
	const classes = useStyles();
	const {
		id,
		color,
		round,
		children,
		fullWidth,
		disabled,
		simple,
		size,
		block,
		link,
		justIcon,
		className,
		muiClasses,
		...rest
	} = props;
	const cardHeaderClasses = classNames({
		[classes.button]: true,
		[classes[size]]: size,
		[classes[color]]: color,
		[classes.round]: round,
		[classes.fullWidth]: fullWidth,
		[classes.disabled]: disabled,
		[classes.simple]: simple,
		[classes.block]: block,
		[classes.link]: link,
		[classes.justIcon]: justIcon,
		[className]: className,
	});
	return (
		<Button {...rest} className={cardHeaderClasses}>
			{children}
		</Button>
	);
}
